import { useEffect, useEffectEvent, useState } from "react";

export const useCountdown = (
  seconds: number,
  onComplete: () => void,
  enabled: boolean
): { remaining: number } => {
  const [remaining, setRemaining] = useState(seconds);
  const onCompleteEvent = useEffectEvent(onComplete);

  useEffect(() => {
    if (!enabled) return;

    let count = seconds;

    const interval = setInterval(() => {
      count -= 1;
      setRemaining(count);
      if (count <= 0) {
        clearInterval(interval);
        onCompleteEvent();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [enabled, seconds]);

  // When disabled (or seconds changes before first tick), reflect seconds directly
  return { remaining: enabled ? remaining : seconds };
};
